import { ISAUSTRALIANLOCATION, RESEARCH_ONLY_LOCATION, MARKETING_REFERRAL_ENABLED_SKUS } from '@/constants';
import { DiscountDetails, MarketingReferral } from '@/types';

const isBrowser = typeof window !== 'undefined';

function getParam(param: string) {
  const match = isBrowser ? RegExp(`[?&]${param}=([^&]*)`).exec(window.location.search) : '';
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export const getDiscountsFromURL = () => {
  const discountFromParams = getParam('discount');

  if (discountFromParams && /^[a-zA-Z0-9_-]*$/.test(discountFromParams)) {
    return discountFromParams.toUpperCase();
  }

  return null;
};

export const removeDiscountParamFromURL = () => {
  if (isBrowser) {
    const url = new URL(window.location.href);
    url.searchParams.delete('discount');
    window.history.replaceState({}, '', url.toString());
  }
};

export const isDiscountValidForLocationAndSku = (
  discount: DiscountDetails | null,
  locationId: string,
  skuId: string | number,
) => {
  if (!discount || !discount.validLocations || !discount.validSkus) {
    return false;
  }

  const isDiscountValidForLocation = discount.validLocations.includes(locationId);
  const isDiscountValidForSku = discount.validSkus.includes(String(skuId));

  return isDiscountValidForLocation && isDiscountValidForSku;
};

export const getReferralCodeFromURL = () => {
  return getParam('referralCode');
};

export const isReferralValidForLocationAndSku = (
  marketingReferral: MarketingReferral | null,
  locationId: string,
  skuId: string | number,
) => {
  if (!marketingReferral || !marketingReferral.isValid) {
    return false;
  }

  const isReferralValidForLocation = !(RESEARCH_ONLY_LOCATION === locationId || ISAUSTRALIANLOCATION(locationId));
  const isReferralValidForSku = MARKETING_REFERRAL_ENABLED_SKUS.includes(String(skuId));
  return isReferralValidForLocation && isReferralValidForSku;
};

export const checkPromoCodeAndReferral = ({
  discount,
  marketingReferral,
  locationId,
  skuId,
}: {
  discount?: DiscountDetails;
  marketingReferral?: MarketingReferral;
  locationId?: string;
  skuId?: string | number;
}) => {
  let isValidDiscount = false;
  let isValidReferral = !!marketingReferral?.isValid;

  const discountAmount = Number(discount?.amount);
  const referralValue = Number(marketingReferral?.referralValue);

  if (locationId && skuId) {
    if (discount) {
      isValidDiscount = isDiscountValidForLocationAndSku(discount, locationId, skuId);
    }
    if (marketingReferral) {
      isValidReferral = isReferralValidForLocationAndSku(marketingReferral, locationId, skuId);
    }
  } else {
    isValidDiscount = !!discount?.promoID;
  }
  if (!discountAmount) {
    isValidDiscount = false;
  }
  if (!referralValue) {
    isValidReferral = false;
  }

  if (!isValidDiscount || !isValidReferral) {
    return {
      discount: isValidDiscount ? discount : null,
      marketingReferral: isValidReferral ? marketingReferral : null,
      errorMessage: marketingReferral?.message,
    };
  }
  if (discountAmount && Number(discountAmount) > referralValue) {
    return {
      discount: isValidDiscount ? discount : null,
      marketingReferral: null,
      errorMessage: marketingReferral?.message,
    };
  }

  // If equal value, use referral
  if (discountAmount && Number(discountAmount) <= referralValue) {
    return {
      discount: null,
      marketingReferral: isValidReferral ? marketingReferral : null,
      errorMessage: marketingReferral?.message,
    };
  }
  return { discount: null, marketingReferral: null, errorMessage: marketingReferral?.message };
};
